// Per-(user, table) "pulled up to" cursor for incremental sync: the merge pulls
// only rows changed at/after this timestamp, then advances it. Kept in
// localStorage so a returning device pulls just the delta, keyed by user so two
// accounts on one browser don't share a cursor. Injectable so tests (and any
// non-browser context) run against an in-memory map instead.

export interface HighWaterStore {
  get(key: string): number; // 0 when unset
  set(key: string, value: number): void;
  has(key: string): boolean;
}

export function createHighWaterStore(): HighWaterStore {
  // Fall back to in-memory if localStorage is unavailable (non-browser).
  if (typeof localStorage === "undefined") return memHighWaterStore();
  return {
    get: (key) => Number(localStorage.getItem(key)) || 0,
    set: (key, value) => localStorage.setItem(key, String(value)),
    has: (key) => localStorage.getItem(key) !== null,
  };
}

export function memHighWaterStore(): HighWaterStore {
  const m = new Map<string, number>();
  return {
    get: (key) => m.get(key) ?? 0,
    set: (key, value) => void m.set(key, value),
    has: (key) => m.has(key),
  };
}
